<script setup lang="ts">
import { reactive, watch } from 'vue'
import type { NewsData } from '~/composables/news/interface'
import { useNews } from '~/composables/news/use-news'
import { sideBarCategories } from '~/resources/news'
import NewsItem from '~/components/common/news/news-item.vue'
import LoadingSpin from '~common/loading-spin.vue'
import NewsNoData from '~/components/mobile/pages/news/news-no-data.vue'

const props = defineProps({
  categorySlug: {
    type: String,
    default: ''
  }
})
const { fetchAllCategoryData, currentCategoryIndex, totalPost, postsPerPage, loadMore, isLoading } = useNews()
const dataNews = reactive<NewsData[]>([])
watch(
  () => props.categorySlug,
  value => {
    currentCategoryIndex.value = sideBarCategories.findIndex(item => item.slug === value)
    isLoading.value = true
    if (!dataNews[currentCategoryIndex.value]?.data?.length) {
      fetchAllCategoryData(dataNews, 0, postsPerPage.value, value)
    }
  },
  { immediate: true }
)
</script>
<template>
  <div class="news-category">
    <LoadingSpin v-if="isLoading && !dataNews[currentCategoryIndex]?.data" />
    <div v-else-if="dataNews[currentCategoryIndex]?.data?.length" class="news-list">
      <div v-for="item in dataNews[currentCategoryIndex]?.data" :key="item.slug">
        <NewsItem :item="item" :categoryName="dataNews[currentCategoryIndex]?.category?.name?.toLowerCase() ?? ''" />
      </div>
    </div>
    <NewsNoData v-else />
    <div
      v-if="dataNews[currentCategoryIndex]?.data?.length && totalPost > dataNews[currentCategoryIndex]?.data?.length"
      class="load-more"
      @click="loadMore(dataNews, categorySlug)"
    >
      Tải thêm
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/news/index.scss';
@import '~scssAsset/mobile/news/news-category.scss';
</style>
